import { makeStyles } from '@material-ui/core';

export const useBundleDetailsStepStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(0.5),
    },
    section: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 8,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        background: '#fcfcfd',
        display: 'flex',
        flexDirection: 'column',
    },
    helperText: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
    },
    helperTextError: {
        fontSize: '0.75rem',
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
    },
    activityListHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    activityListLabel: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
    },
    required: {
        color: theme.palette.error.main,
        marginLeft: 2,
    },
    selectedCount: {
        fontSize: '0.75rem',
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    activityList: {
        maxHeight: 260,
        overflowY: 'auto',
        marginTop: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
        background: theme.palette.background.paper,
    },
    selectAllRow: {
        display: 'flex',
        width: '100%',
        margin: 0,
        padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
        borderBottom: `1px solid ${theme.palette.divider}`,
        '& .MuiFormControlLabel-label': {
            fontWeight: 600,
            fontSize: '0.8rem',
            color: theme.palette.text.primary,
        },
    },
    activityRow: {
        display: 'flex',
        width: '100%',
        margin: 0,
        padding: `${theme.spacing(0.25)}px ${theme.spacing(1)}px`,
        '&:hover': {
            background: theme.palette.action.hover,
        },
        '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            color: theme.palette.text.primary,
        },
    },
    noResults: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        textAlign: 'center',
        padding: theme.spacing(2),
        margin: 0,
    },
}));